import React, { useState } from 'react';
import LayoutDashboard from '../layout/LayoutDashboard';
import { Icon } from '@iconify/react';
import searchOutlined from '@iconify/icons-ant-design/search-outlined';

import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import ListAccount from '../components/Account/ListAccount';

const Account = () => {
  return (
    <>
      <LayoutDashboard>
        <section className="ml-4 w-full">
          <div className="md-flex">
            <div className="bg-white">
              <div class="mb-4">
                <div className="flex align-middle rounded-tl-lg rounded-tr-lg  w-full py-4 overflow-hidden bg-white shadow-lg px-12">
                  <div class="flex">
                    <input
                      class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      placeholder="Pencarian"
                      aria-label="Full name"
                    />
                    <button className="bg-green-100 text-white font-bold py-2 px-4 rounded">
                      <Icon
                        icon={searchOutlined}
                        className="text-2xl text-white"
                      />
                    </button>
                  </div>
                  <button className="bg-orange-500 text-white font-bold py-2 px-4 rounded ml-auto">
                    <Link to="/account/add-account">+ Rekening Baru</Link>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="md-flex">
            <ListAccount />
          </div>
        </section>
      </LayoutDashboard>
    </>
  );
};

export default Account;
